import { PastShift } from '../models';

export function locationAddress(location?: PastShift['business_location']) {
    if (!location) return '';
    return `${location.address.street} ${location.address.city}, ${location.address.state} ${location.address.zip_code}`;
}
